import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  NgForm,
} from "@angular/forms";
import { Location } from "@angular/common";
import { QuestionsService } from "../../services/questions.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ErrorService } from "../../services/error.service";
import { FlashService } from "../../flash/flash.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-questionscreate",
  templateUrl: "./create.component.html",
  styleUrls: ["./create.component.css"],
})
export class QuestionscreateComponent implements OnInit {
  constructor(
    private location: Location,
    private questionservice: QuestionsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private flashService: FlashService,
    private router: Router
  ) {}

  questionForm = new FormGroup({
    name: new FormControl("", Validators.required),
    type: new FormControl("", Validators.required),
    category: new FormControl("", Validators.required),
  });

  errors;
  categ_data:any;

  ngOnInit() {
    this.get_category_data()
  }

  options: boolean = false;
  option_data: Array<any> = [];
  option_error: boolean = false;

  change(e) {
    if (e.target.value === "dropdown" || e.target.value === "radio" || e.target.value === "checkbox") {
      this.options = true;
    } else {
      return (this.options = false);
    }
  }

  onSubmit() {
    this.option_data = [];
    this.option_error = false;

    if (
      this.questionForm.value.type === "dropdown" ||
      this.questionForm.value.type === "radio" || this.questionForm.value.type === "checkbox"
    ) {
      this.tags.forEach((item) => {
        this.option_data.push(item.name);
      });

      if(this.option_data.length === 0){
        this.option_error = true
        
      }
    }
    

    this.questionForm.value.options = this.option_data;

    //remove dot in question name
    this.questionForm.value.name = this.questionForm.value.name.split('.').join("");

   if(this.option_error === false){
     this.spinnerService.show();
    this.questionservice.createQuestion(this.questionForm.value).subscribe(
      (data) => {
        this.spinnerService.hide();
        if (data.body.success) {
          this.flashService.show(data.body["message"], "alert-success");
          this.router.navigateByUrl("questions/list");
        } else {
          this.errors = data.body["message"];
          this.flashService.show(data.body["message"], "alert-danger");
        }
      },
      (error) => {
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );

   }
  }

  locationBack() {
    this.location.back();
  }

  get name() {
    return this.questionForm.get("name");
  }

  get category() {
    return this.questionForm.get("category");
  }

  get type() {
    return this.questionForm.get("type");
  }

  tags: any[] = [
    // { name: 'An' },
    // { name: 'React' }
  ];

  onTagRemoved(tag: any) {
    const index = this.tags.findIndex(
      (t) => t.name.toLowerCase() === tag.name.toLowerCase()
    );
    if (index !== -1) {
      this.tags = [...this.tags.slice(0, index), ...this.tags.slice(index + 1)];
    }
  }

  onTagAdded(tag: any) {
    const index = this.tags.findIndex(
      (t) => t.name.toLowerCase() === tag.name.toLowerCase()
    );
    if (index === -1) {
      this.tags = [...this.tags, tag];
    }
  }

  get_category_data(){
    this.questionservice.getQuestionsCategoryDd().subscribe(
      (data) => {
        this.spinnerService.hide();
        this.categ_data = data.body
      },
      (error) => {
        console.log("Get category data error:",error);
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/create/create.component.ts